import React, { useEffect, useState } from 'react';
import { Form, Modal, Spinner } from 'react-bootstrap';
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { api_url } from "../api/config/config";
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const Search: React.FC<{ onClose: any }> = ({ onClose }) => {
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();
    // const [contractCategories, setContractCategories] = useState<string[]>([]);
    const [sectionOpen, setSectionOpen] = useState({
        pink: true,
        blue: true,
        orange: true,
        green: true,
        yellow: true,
        red: true,
    });


    const [isCustomUsage, setIsCustomUsage] = useState<boolean>(false);
    const [customUsageFrom, setCustomUsageFrom] = useState<number>();
    const [customUsageTo, setCustomUsageTo] = useState<number>();
    const [isCustomContractUsage, setIsCustomContractUsage] = useState<boolean>(false);
    const [customContractUsageFrom, setCustomContractUsageFrom] = useState<number>();
    const [customContractUsageTo, setCustomContractUsageTo] = useState<number>();
    const [isCustomLoad, setIsCustomLoad] = useState<boolean>(false);
    const [customLoadFrom, setCustomLoadFrom] = useState<number>();
    const [customLoadTo, setCustomLoadTo] = useState<number>();
    const [companyCount, setCompanyCount] = useState<number>(0);
    const [facilityCount, setFacilityCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const [contractCategories, setContractCategories] = useState<any[]>([
        { checked: false, label: "特別高圧", value: "1" },
        { checked: false, label: "高圧電力", value: "2" },
        { checked: false, label: "従量電灯", value: "3" },
        { checked: false, label: "低圧電力", value: "4" },
    ]);

    const [usages, setUsages] = useState<any[]>([
        { checked: false, label: "～100,000kWh", value: "u1" },
        { checked: false, label: "100,001kWh～300,000kWh", value: "u2" },
        { checked: false, label: "300,001kWh～500,000kWh", value: "u3" },
        { checked: false, label: "500,001kWh～1,000,000kWh", value: "u4" },
        { checked: false, label: "1,000,000kWh～2,000,000kWh", value: "u5" },
        { checked: false, label: "2,000,000kWh～5,000,000kWh", value: "u6" },
        { checked: false, label: "5,000,000kWh～10,000,000kWh", value: "u7" },
        { checked: false, label: "10,000,000kWh～", value: "u8" },
    ]);



    const [contractUsages, setContractUsages] = useState<any[]>([
        { checked: false, label: "～100kW", value: "c1" },
        { checked: false, label: "100～250kW", value: "c2" },
        { checked: false, label: "250～400kW", value: "c3" },
        { checked: false, label: "400～550kW", value: "c4" },
        { checked: false, label: "550～700kW", value: "c5" },
        { checked: false, label: "700～850kW", value: "c6" },
        { checked: false, label: "850～1000kW", value: "c7" },
        { checked: false, label: "1000kW～", value: "c8" },
    ]);


    const [loads, setloads] = useState<any[]>([
        { checked: false, label: " ～20％", value: "l1" },
        { checked: false, label: "20～30％", value: "l2" },
        { checked: false, label: " 30～40％", value: "l3" },
        { checked: false, label: "40～50％", value: "l4" },
        { checked: false, label: "50～60％", value: "l5" },
        { checked: false, label: "60％～", value: "l6" },

    ]);


    const [groupsState, setGroupsState] = useState([
        {
            parent: { checked: false, label: "北海道電力管内", value: 'a1' },
            type: 'prefecture',
            children: [
                { checked: false, label: "北海道", value: 'a1' }
            ],
        }, // 北海道電力管内 group
        {
            parent: { checked: false, label: "東北電力管内", value: 'a2' },
            type: 'prefecture',
            children: [
                { checked: false, label: "青森", value: 'a21' },
                { checked: false, label: "岩手", value: 'a22' },
                { checked: false, label: "秋田", value: 'a23' },
                { checked: false, label: "宮城", value: 'a24' },
                { checked: false, label: "山形", value: 'a25' },
                { checked: false, label: "福島", value: 'a26' },
                { checked: false, label: "新潟", value: 'a27' },
            ],
        }, // 東北電力管内 group
        {
            parent: { checked: false, label: "北陸電力管内", value: 'a3' },
            type: 'prefecture',
            children: [
                { checked: false, label: "岐阜", value: 'a31' },
                { checked: false, label: "富山", value: 'a32' },
                { checked: false, label: "石川", value: 'a33' },
                { checked: false, label: "福井(美浜町以東)", value: 'a34' },
            ],
        }, // 北陸電力管内 group
        {
            parent: { checked: false, label: "東京電力管内", value: 'a4' },
            type: 'prefecture',
            children: [
                { checked: false, label: "東京", value: 'a41' },
                { checked: false, label: "神奈川", value: 'a42' },
                { checked: false, label: "千葉", value: 'a43' },
                { checked: false, label: "埼玉", value: 'a44' },
                { checked: false, label: "茨城", value: 'a45' },
                { checked: false, label: "栃木", value: 'a46' },
                { checked: false, label: "群馬", value: 'a47' },
                { checked: false, label: "山梨", value: 'a48' },
                { checked: false, label: "静岡(富士川以東)", value: 'a49' },
            ],
        }, // 東京電力管内 group
        {
            parent: { checked: false, label: "中部電力管内", value: 'a5' },
            type: 'prefecture',
            children: [
                { checked: false, label: "愛知", value: 'a51' },
                { checked: false, label: "長野", value: 'a52' },
                { checked: false, label: "静岡(富士川以西,芝川町内房)", value: 'a53' },
                { checked: false, label: "三重(熊野市-新鹿町,磯崎町,大泊町,須野町,二木島里町,二木島町,波田須町,甫母町,遊木町を含む)以北", value: 'a54' },
                { checked: false, label: "静岡(富士川以西)", value: 'a55' },
            ],
        }, // 中部電力管内 group
        {
            parent: { checked: false, label: "関西電力管内", value: 'a6' },
            type: 'prefecture',
            children: [
                { checked: false, label: "大阪", value: 'a61' },
                { checked: false, label: "京都", value: 'a62' },
                { checked: false, label: "兵庫(赤穂市福浦を除く)", value: 'a63' },
                { checked: false, label: "奈良", value: 'a64' },
                { checked: false, label: "滋賀", value: 'a65' },
                { checked: false, label: "和歌山", value: 'a66' },
                { checked: false, label: "福井(美浜町以西)", value: 'a67' },
                { checked: false, label: "岐阜(関ケ原町今須)", value: 'a68' },
                { checked: false, label: "三重(熊野市（新鹿町,磯崎町,大泊町,須野町,二木島里町,二木島町,波田須町,甫母町,遊木町を除く）以南", value: 'a69' },
            ],
        }, // 関西電力管内 group
        {
            parent: { checked: false, label: "中国電力管内", value: 'a7' },
            type: 'prefecture',
            children: [
                { checked: false, label: "鳥取", value: 'a71' },
                { checked: false, label: "島根", value: 'a72' },
                { checked: false, label: "岡山", value: 'a73' },
                { checked: false, label: "広島", value: 'a74' },
                { checked: false, label: "山口", value: 'a75' },
                { checked: false, label: "兵庫(赤穂市福浦)", value: 'a76' },
                { checked: false, label: "香川(小豆群,香川群直島町)", value: 'a77' },
                { checked: false, label: "愛媛(越智郡上島町,今治市上浦町,大三島町,伯方町,吉海町,宮窪町,関前大下,関前岡村,関前小大下)", value: 'a78' },
            ],
        }, // 中国電力管内 group
        {
            parent: { checked: false, label: "四国電力管内", value: 'a8' },
            type: 'prefecture',
            children: [
                { checked: false, label: "高知", value: 'a81' },
                { checked: false, label: "徳島", value: 'a82' },
                { checked: false, label: "香川(小豆郡，香川郡直島町を除く)", value: 'a83' },
                { checked: false, label: "愛媛(越智郡上島町,今治市上浦町,大三島町,伯方町,吉海町,宮", value: 'a84' },
            ]
        }, // 四国電力管内 group
        {
            parent: { checked: false, label: "九州電力管内", value: 'a9' },
            type: 'prefecture',
            children: [
                { checked: false, label: "福岡", value: 'a91' },
                { checked: false, label: "佐賀", value: 'a92' },
                { checked: false, label: "長崎", value: 'a93' },
                { checked: false, label: "大分", value: 'a94' },
                { checked: false, label: "熊本", value: 'a95' },
                { checked: false, label: "宮崎", value: 'a96' },
                { checked: false, label: "鹿児島", value: 'a97' },
            ]
        }, // 九州電力管内 group
        {
            parent: { checked: false, label: "沖縄電力管内", value: 'a0' },
            type: 'prefecture',
            children: [
                { checked: false, label: "沖縄", value: 'a0' },

            ]
        }, // 沖縄電力管内 group
        {
            parent: { checked: false, label: "農業，林業", value: 'i1' },
            type: 'industry',
            children: [
                { checked: false, label: "農業", value: "i11" },
                { checked: false, label: "林業", value: "i12" },
                { checked: false, label: "その他の農業，林業", value: "i13" },
            ]
        },
        {
            parent: { checked: false, label: "漁業", value: 'i2' },
            type: 'industry',
            children: [
                { checked: false, label: "漁業（水産養殖業を除く）", value: "i21" },
                { checked: false, label: "水産養殖業", value: "i22" },
                { checked: false, label: "その他の漁業", value: "i23" },
            ]
        },
        {
            parent: { checked: false, label: "鉱業，採石業，砂利採取業", value: 'i3' },
            type: 'industry',
            children: [
                { checked: false, label: "鉱業，採石業，砂利採取業", value: "i31" },
            ]
        },
        {
            parent: { checked: false, label: "建設業", value: 'i4' },
            type: 'industry',
            children: [
                { checked: false, label: "総合工事業", value: "i41" },
                { checked: false, label: "職別工事業（設備工事業を除く）", value: "i42" },
                { checked: false, label: "設備工事業", value: "i43" },
                { checked: false, label: "その他の建設業", value: "i44" },
            ]
        },
        {
            parent: { checked: false, label: "製造業", value: 'i5' },
            type: 'industry',
            children: [
                { checked: false, label: "食料品製造業", value: "i51" },
                { checked: false, label: "飲料・たばこ・飼料製造業", value: "i52" },
                { checked: false, label: "繊維工業", value: "i53" },
                { checked: false, label: "木材・木製品製造業（家具を除く）", value: "i54" },
                { checked: false, label: "家具・装備品製造業", value: "i55" },
                { checked: false, label: "パルプ・紙・紙加工品製造業", value: "i56" },
                { checked: false, label: "印刷・同関連業", value: "i57" },
                { checked: false, label: "化学工業", value: "i58" },
                { checked: false, label: "石油製品・石炭製品製造業", value: "i59" },
                { checked: false, label: "プラスチック製品製造業（別掲を除く）", value: "i510" },
                { checked: false, label: "ゴム製品製造業", value: "i511" },
                { checked: false, label: "なめし革・同製品・毛皮製造業", value: "i512" },
                { checked: false, label: "窯業・土石製品製造業", value: "i513" },
                { checked: false, label: "鉄鋼業", value: "i514" },
                { checked: false, label: "非鉄金属製造業", value: "i515" },
                { checked: false, label: "金属製品製造業", value: "i516" },
                { checked: false, label: "はん用機械器具製造業", value: "i517" },
                { checked: false, label: "生産用機械器具製造業", value: "i518" },
                { checked: false, label: "業務用機械器具製造業", value: "i519" },
                { checked: false, label: "電子部品・デバイス・電子回路製造業", value: "i520" },
                { checked: false, label: "電気機械器具製造業", value: "i521" },
                { checked: false, label: "情報通信機械器具製造業", value: "i522" },
                { checked: false, label: "輸送用機械器具製造業", value: "i523" },
                { checked: false, label: "その他の製造業", value: "i524" },
            ]
        },
        {
            parent: { checked: false, label: "電気・ガス・熱供給・水道業", value: 'i6' },
            type: 'industry',
            children: [
                { checked: false, label: "電気業", value: "i61" },
                { checked: false, label: "ガス業", value: "i62" },
                { checked: false, label: "熱供給業", value: "i63" },
                { checked: false, label: "水道業", value: "i64" },
                { checked: false, label: "その他の電気・ガス・熱供給・水道業", value: "i65" },
            ]
        },
        {
            parent: { checked: false, label: "情報通信業", value: 'i7' },
            type: 'industry',
            children: [
                { checked: false, label: "通信業", value: "i71" },
                { checked: false, label: "放送業", value: "i72" },
                { checked: false, label: "情報サービス業", value: "i73" },
                { checked: false, label: "インターネット附随サービス業", value: "i74" },
                { checked: false, label: "映像・音声・文字情報制作業", value: "i75" },
                { checked: false, label: "その他の情報通信業", value: "i76" },
            ]
        },
        {
            parent: { checked: false, label: "運輸業，郵便業", value: 'i8' },
            type: 'industry',
            children: [
                { checked: false, label: "鉄道業", value: "i81" },
                { checked: false, label: "道路旅客運送業", value: "i82" },
                { checked: false, label: "道路貨物運送業", value: "i83" },
                { checked: false, label: "水運業", value: "i84" },
                { checked: false, label: "航空運輸業", value: "i85" },
                { checked: false, label: "倉庫業", value: "i86" },
                { checked: false, label: "運輸に附帯するサービス業", value: "i87" },
                { checked: false, label: "郵便業（信書便事業を含む）", value: "i88" },
                { checked: false, label: "その他の運輸業，郵便業", value: "i89" },
            ]
        },
        {
            parent: { checked: false, label: "卸売業，小売業", value: 'i9' },
            type: 'industry',
            children: [
                { checked: false, label: "各種商品卸売業", value: "i91" },
                { checked: false, label: "繊維・衣服等卸売業", value: "i92" },
                { checked: false, label: "飲食料品卸売業", value: "i93" },
                { checked: false, label: "建築材料，鉱物・金属材料等卸売業", value: "i94" },
                { checked: false, label: "機械器具卸売業", value: "i95" },
                { checked: false, label: "その他の卸売業", value: "i96" },
                { checked: false, label: "各種商品小売業", value: "i97" },
                { checked: false, label: "織物・衣服・身の回り品小売業", value: "i98" },
                { checked: false, label: "飲食料品小売業", value: "i99" },
                { checked: false, label: "機械器具小売業", value: "i910" },
                { checked: false, label: "無店舗小売業", value: "i911" },
                { checked: false, label: "その他の小売業", value: "i912" },
            ]
        },
        {
            parent: { checked: false, label: "金融業，保険業", value: 'i10' },
            type: 'industry',
            children: [
                { checked: false, label: "銀行業", value: "i101" },
                { checked: false, label: "協同組織金融業", value: "i102" },
                { checked: false, label: "貸金業，クレジットカード業等非預金信用機関", value: "i103" },
                { checked: false, label: "金融商品取引業，商品先物取引業", value: "i104" },
                { checked: false, label: "補助的金融業等", value: "i105" },
                { checked: false, label: "保険業（保険媒介代理業，保険サ－ビス業を含む）", value: "i106" },
                { checked: false, label: "その他の金融業，保険業", value: "i107" },
            ]
        },
        {
            parent: { checked: false, label: "不動産業，物品賃貸業", value: 'i11' },
            type: 'industry',
            children: [
                { checked: false, label: "不動産取引業", value: "i111" },
                { checked: false, label: "不動産賃貸業・管理業", value: "i112" },
                { checked: false, label: "物品賃貸業", value: "i113" },
                { checked: false, label: "その他の不動産業，物品賃貸業", value: "i114" },
            ]
        },
        {
            parent: { checked: false, label: "学術研究，専門・技術サービス業", value: 'i12' },
            type: 'industry',
            children: [
                { checked: false, label: "学術・開発研究機関", value: "i121" },
                { checked: false, label: "専門サービス業", value: "i122" },
                { checked: false, label: "広告業", value: "i123" },
                { checked: false, label: "技術サービス業", value: "i124" },
                { checked: false, label: "その他の学術研究，専門・技術サービス業", value: "i125" },
            ]
        },
        {
            parent: { checked: false, label: "宿泊業，飲食サービス業", value: 'i13' },
            type: 'industry',
            children: [
                { checked: false, label: "宿泊業", value: "i131" },
                { checked: false, label: "飲食店", value: "i132" },
                { checked: false, label: "持ち帰り・配達飲食サービス業", value: "i133" },
                { checked: false, label: "その他の宿泊業，飲食サービス業", value: "i134" },
            ]
        },
        {
            parent: { checked: false, label: "生活関連サービス業，娯楽業", value: 'i14' },
            type: 'industry',
            children: [
                { checked: false, label: "洗濯・理容･美容･浴場業", value: "i141" },
                { checked: false, label: "その他の生活関連サービス業", value: "i142" },
                { checked: false, label: "娯楽業", value: "i143" },
            ]
        },
        {
            parent: { checked: false, label: "教育，学習支援業", value: 'i15' },
            type: 'industry',
            children: [
                { checked: false, label: "学校教育", value: "i151" },
                { checked: false, label: "その他の教育，学習支援業", value: "i152" },
            ]
        },
        {
            parent: { checked: false, label: "医療，福祉", value: 'i16' },
            type: 'industry',
            children: [
                { checked: false, label: "医療業", value: "i161" },
                { checked: false, label: "保健衛生", value: "i162" },
                { checked: false, label: "社会保険・社会福祉・介護事業", value: "i163" },
                { checked: false, label: "その他の医療，福祉", value: "i164" },
            ]
        },
        {
            parent: { checked: false, label: "複合サービス事業", value: 'i17' },
            type: 'industry',
            children: [
                { checked: false, label: "郵便局", value: "i171" },
                { checked: false, label: "協同組合（他に分類されないもの）", value: "i172" },
                { checked: false, label: "その他の複合サービス事業", value: "i173" },
            ]
        },
        {
            parent: { checked: false, label: "サービス業（他に分類されないもの）", value: 'i18' },
            type: 'industry',
            children: [
                { checked: false, label: "廃棄物処理業", value: "i181" },
                { checked: false, label: "自動車整備業", value: "i182" },
                { checked: false, label: "機械等修理業（別掲を除く）", value: "i183" },
                { checked: false, label: "職業紹介・労働者派遣業", value: "i184" },
                { checked: false, label: "その他の事業サービス業", value: "i185" },
                { checked: false, label: "政治・経済・文化団体", value: "i186" },
                { checked: false, label: "宗教", value: "i187" },
                { checked: false, label: "その他のサービス業", value: "i188" },
            ]
        },
        {
            parent: { checked: false, label: "公務(他に分類されるものを除く）", value: 'i19' },
            type: 'industry',
            children: [
                { checked: false, label: "外国公務", value: "i191" },
                { checked: false, label: "国家公務", value: "i192" },
                { checked: false, label: "地方公務", value: "i193" },
                { checked: false, label: "その他の公務", value: "i194" },
            ]
        },
        {
            parent: { checked: false, label: "分類不能の産業", value: 'i20' },
            type: 'industry',
            children: [
                { checked: false, label: "分類不能の産業", value: "i201" },
            ]
        },




        // {
        //     parent: { checked: false, label: "水産・農林業", value: 'i1' },
        //     type: 'industry',
        //     children: [

        //         // { checked: false, label: "水産・農林業", value: "i1" },
        //     ]
        // },
        // {
        //     parent: { checked: false, label: "鉱業", value: 'i2' },
        //     type: 'industry',
        //     children: [
        //         // { checked: false, label: "鉱業", value: "i2" },
        //     ]
        // },
        // {
        //     parent: { checked: false, label: "建設業", value: 'i3' },
        //     type: 'industry',
        //     children: [
        //         // { checked: false, label: "建設業", value: "i3" },
        //     ]
        // },
        // {
        //     parent: { checked: false, label: "製造業", value: 'i4' },
        //     type: 'industry',
        //     children: [
        //         { checked: false, label: "食料品", value: "i401" },
        //         { checked: false, label: "繊維製品", value: "i402" },
        //         { checked: false, label: "パルプ・紙", value: "i403" },
        //         { checked: false, label: "化学", value: "i404" },
        //         { checked: false, label: "医薬品", value: "i405" },
        //         { checked: false, label: "石油・石炭製品", value: "i406" },
        //         { checked: false, label: "ゴム製品", value: "i407" },
        //         { checked: false, label: "ガラス・土石製品", value: "i408" },
        //         { checked: false, label: "鉄鋼", value: "i409" },
        //         { checked: false, label: "非鉄金属", value: "i410" },
        //         { checked: false, label: "金属製品", value: "i411" },
        //         { checked: false, label: "機械", value: "i412" },
        //         { checked: false, label: "電気機器", value: "i413" },
        //         { checked: false, label: "輸送用機器", value: "i414" },
        //         { checked: false, label: "精密機器", value: "i415" },
        //         { checked: false, label: "その他製品", value: "i416" },
        //     ]
        // }, // 製造業 group
        // {
        //     parent: { checked: false, label: "電気・ガス", value: 'i5' },
        //     type: 'industry',
        //     children: [
        //         // { checked: false, label: "建設業", value: "i3" },
        //     ]
        // },
        // {
        //     parent: { checked: false, label: "運輸・情報通信業", value: "i6" },
        //     type: 'industry',
        //     children: [
        //         { checked: false, label: "陸運業", value: "i601" },
        //         { checked: false, label: "海運業", value: "i602" },
        //         { checked: false, label: "空運業", value: "i603" },
        //         { checked: false, label: "倉庫・運輸関連業", value: "i604" },
        //         { checked: false, label: "情報通信業", value: "i605" },
        //     ]
        // }, // 運輸・情報通信業 group
        // {
        //     parent: { checked: false, label: "商業", value: "i7" },
        //     type: 'industry',
        //     children: [
        //         { checked: false, label: "卸売業", value: "i701" },
        //         { checked: false, label: "小売業", value: "i702" },
        //     ]
        // }, // 商業 group
        // {
        //     parent: { checked: false, label: "金融・保険業", value: "i8" },
        //     type: 'industry',
        //     children: [
        //         { checked: false, label: "銀行業", value: "i801" },
        //         { checked: false, label: "証券・商品先物取引業", value: "i802" },
        //         { checked: false, label: "保険業", value: "i803" },
        //         { checked: false, label: "その他金融業", value: "i804" },
        //     ]
        // }, // 金融・保険業 group
        // {
        //     parent: { checked: false, label: "不動産業", value: 'i9' },
        //     type: 'industry',
        //     children: [
        //         // { checked: false, label: "建設業", value: "i3" },
        //     ]
        // },
        // {
        //     parent: { checked: false, label: "サービス業", value: 'i10' },
        //     type: 'industry',
        //     children: [
        //         // { checked: false, label: "建設業", value: "i3" },
        //     ]
        // },

    ]);

    const handleParentChange = (groupIndex: number) => (event: { target: { checked: any; }; }) => {
        const updatedGroups: any = groupsState.map((group, index) => {
            if (index === groupIndex) {
                return {
                    ...group,
                    parent: { ...group.parent, checked: event.target.checked },
                    children: group.children.map(child => ({ ...child, checked: event.target.checked })),
                };
            }
            return group;
        });
        setGroupsState(updatedGroups);
    };

    const handleChildChange = (groupIndex: number, childIndex: number) => (event: { target: { checked: any; }; }) => {


        const updatedGroups: any = groupsState.map((group, index) => {
            if (index === groupIndex) {
                const updatedChildren = group.children.map((child, i) =>
                    i === childIndex ? { ...child, checked: event.target.checked } : child
                );
                const allChecked = updatedChildren.every(child => child.checked);
                return {
                    ...group,
                    parent: { ...group.parent, checked: allChecked },
                    children: updatedChildren,
                };
            }
            return group;
        });
        setGroupsState(updatedGroups);
    };


    const handleChildClose = (groupIndex: number, childIndex: number) => {

        const updatedGroups: any = groupsState.map((group, index) => {
            if (index === groupIndex) {
                const updatedChildren = group.children.map((child, i) =>
                    i === childIndex ? { ...child, checked: false } : child
                );
                const allChecked = updatedChildren.every(child => child.checked);
                return {
                    ...group,
                    parent: { ...group.parent, checked: allChecked },
                    children: updatedChildren,
                };
            }
            return group;
        });
        setGroupsState(updatedGroups);
    };

    const getSearchValue = () => {
        const categories = contractCategories.map((contractCategory) => {
            return contractCategory.checked ? contractCategory.value : null
        }).filter(Boolean);
        const prefectureGroups = groupsState.filter(group => group.type === 'prefecture');
        const industryGroups = groupsState.filter(group => group.type === 'industry');
        const area: any = [];
        const industry: any = [];
        const checkedUsages: any = [];
        const checkedContractUsages: any = [];
        const checkedLoads: any = [];
        let usage_custom_from = null;
        let usage_custom_to = null;
        let contract_usage_from = null;
        let contract_usage_to = null;
        let load_custom_from = null;
        let load_custom_to = null;

        // 地域
        prefectureGroups.forEach((group) => {
            if (group.parent.checked) {
                area.push(group.parent.value);
            }
            group.children.forEach((child: any) => {
                if (child.checked) {
                    area.push(child.value);
                }
            });
        });

        // 業種
        industryGroups.forEach((group) => {
            // if (group.parent.checked) {
            //     industry.push(group.parent.value);
            // }
            group.children.forEach((child: any) => {
                if (child.checked) {
                    industry.push(child.value);
                }
            });
        });


        // 使用量
        usages.forEach((usage) => {
            if (usage.checked) {
                checkedUsages.push(usage.value);
            }
        });

        // 契約電力
        contractUsages.forEach((contractUsage: any) => {
            if (contractUsage.checked) {
                checkedContractUsages.push(contractUsage.value);
            }
        });

        // 負荷率
        loads.forEach((load: any) => {
            if (load.checked) {
                checkedLoads.push(load.value);
            }
        });

        if (isCustomUsage) {
            usage_custom_from = customUsageFrom;
            usage_custom_to = customUsageTo;
        }

        if (isCustomContractUsage) {
            contract_usage_from = customContractUsageFrom;
            contract_usage_to = customContractUsageTo;
        }

        if (isCustomLoad) {
            load_custom_from = customLoadFrom;
            load_custom_to = customLoadTo;
        }

        // usage_custom_from: isCustomUsage ? customUsageFrom : 0,
        // usage_custom_to: isCustomUsage ? customUsageTo : 0,
        // contract_usage: checkedContractUsages,
        // contract_usage_from: isCustomContractUsage ? customContractUsageFrom : 0,
        // contract_usage_to: isCustomContractUsage ? customContractUsageTo : 0,
        // load: checkedLoads,
        // load_custom_from: isCustomLoad ? customLoadFrom : 0,
        // load_custom_to: isCustomLoad ? customLoadTo : 0,

        return {
            contract_categories: categories,
            area: area,
            industry: industry,
            usage: checkedUsages,
            contract_usage: checkedContractUsages,
            load: checkedLoads,
            usage_custom_from: usage_custom_from,
            usage_custom_to: usage_custom_to,
            contract_usage_from: contract_usage_from,
            contract_usage_to: contract_usage_to,
            load_custom_from: load_custom_from,
            load_custom_to: load_custom_to,
        }

    }


    const handleSearch = () => {

        const { contract_categories, area, industry, usage, contract_usage, load, usage_custom_from, usage_custom_to, contract_usage_from, contract_usage_to, load_custom_from, load_custom_to } = getSearchValue();
        // const categories = contractCategories.map((contractCategory) => {
        //     return contractCategory.checked ? contractCategory.value : null
        // }).filter(Boolean);
        // const prefectureGroups = groupsState.filter(group => group.type === 'prefecture');
        // const industryGroups = groupsState.filter(group => group.type === 'industry');
        // const area: any = [];
        // const industry: any = [];
        // const checkedUsages: any = [];
        // const checkedContractUsages: any = [];
        // const checkedLoads: any = [];

        // // 地域
        // prefectureGroups.forEach((group) => {
        //     if (group.parent.checked) {
        //         area.push(group.parent.value);
        //     }
        //     group.children.forEach((child: any) => {
        //         if (child.checked) {
        //             area.push(child.value);
        //         }
        //     });
        // });

        // // 業種
        // industryGroups.forEach((group) => {
        //     if (group.parent.checked) {
        //         industry.push(group.parent.value);
        //     }
        //     group.children.forEach((child: any) => {
        //         if (child.checked) {
        //             industry.push(child.value);
        //         }
        //     });
        // });


        // // 使用量
        // usages.forEach((usage) => {
        //     if (usage.checked) {
        //         checkedUsages.push(usage.value);
        //     }
        // });

        // // 契約電力
        // contractUsages.forEach((contractUsage: any) => {
        //     if (contractUsage.checked) {
        //         checkedContractUsages.push(contractUsage.value);
        //     }
        // });

        // // 負荷率
        // loads.forEach((load: any) => {
        //     if (load.checked) {
        //         checkedLoads.push(load.value);
        //     }
        // });

        // Object.keys(prefectureGroups).forEach((key) => {
        //     if (prefectureGroups[key].parent.checked) {
        //         area.push(prefectureGroups[key].parent.value);
        //     }
        //     Object.keys(prefectureGroups[key].children).forEach((childKey) => {
        //         if (prefectureGroups[key].children[childKey].checked) {
        //             area.push(prefectureGroups[key].children[childKey].value);
        //         }
        //     });
        // });


        // navigate(`/search_result`, {
        //     state: {
        //         search:
        //         {
        //             contract_categories: contract_categories,
        //             area: area,
        //             industry: industry,
        //             usage: usage,
        //             usage_custom_from: usage_custom_from,
        //             usage_custom_to: usage_custom_to,
        //             contract_usage: contract_usage,
        //             contract_usage_from: contract_usage_from,
        //             contract_usage_to: contract_usage_to,
        //             load: load,
        //             load_custom_from: load_custom_from,
        //             load_custom_to: load_custom_to,
        //         }
        //     }
        // });
        const searchParams = {
            contract_categories,
            area,
            industry,
            usage,
            usage_custom_from,
            usage_custom_to,
            contract_usage,
            contract_usage_from,
            contract_usage_to,
            load,
            load_custom_from,
            load_custom_to,
        };

        navigate(`/search_result?search=${encodeURIComponent(JSON.stringify(searchParams))}`);

        onClose();
    }

    const handleContractCategoriesChange = (index: number) => (event: { target: { checked: any; }; }) => {
        const checked = event.target.checked;
        const updatedContractCategories = contractCategories.map((contractCategory, i) => {
            if (i === index) {
                return { ...contractCategory, checked };
            }
            return contractCategory;
        });

        setContractCategories(updatedContractCategories);
    }

    const handleContractCategoriesClose = (index: number) => {
        const updatedContractCategories = contractCategories.map((contractCategory, i) => {
            if (i === index) {
                return { ...contractCategory, checked: false };
            }
            return contractCategory;
        });

        setContractCategories(updatedContractCategories);
    }


    const handleUsagesChange = (index: number, checked: boolean) => {
        const updated = usages.map((usage, i) => {
            if (i === index) {
                return { ...usage, checked };
            }
            return usage;
        });

        setUsages(updated);
    }

    const handleContractUsagesChange = (index: number, checked: boolean) => {
        const updated = contractUsages.map((usage, i) => {
            if (i === index) {
                return { ...usage, checked };
            }
            return usage;
        });

        setContractUsages(updated);
    }

    const handleLoadsChange = (index: number, checked: boolean) => {
        const updated = loads.map((load, i) => {
            if (i === index) {
                return { ...load, checked };
            }
            return load;
        });

        setloads(updated);
    }


    const prefectureGroups = groupsState.filter(group => group.type === 'prefecture');
    const industryGroups = groupsState.filter(group => group.type === 'industry');

    const industryLabels: { label: string, groupIndex: number, childIndex: number }[] = [];
    const prefectureLabels: any[] = [];
    const contractCategoryLabels: any[] = [];
    const usageLabels: any[] = [];


    contractCategories.forEach((contractCategory, index) => {
        if (contractCategory.checked === true) {
            contractCategoryLabels.push({
                index,
                label: contractCategory.label
            });
        }
    });


    groupsState.forEach((group, groupIndex) => {
        if (group.type === 'prefecture') {
            group.children.forEach((child, childIndex) => {
                if (child.checked === true) {
                    prefectureLabels.push({
                        groupIndex,
                        childIndex,
                        label: child.label,
                    });

                }
            });
        }
    });


    groupsState.forEach((group, groupIndex) => {
        if (group.type === 'industry') {
            group.children.forEach((child, childIndex) => {
                if (child.checked === true) {
                    industryLabels.push({
                        groupIndex,
                        childIndex,
                        label: child.label,
                    });

                }
            });

        }
    });


    // usages.forEach((usage, index) => {
    //     if (usage.checked === true) {
    //         usageLabels.push({
    //             index,
    //             label: usage.label
    //         });
    //     }
    // });

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(true);
            getCount(getSearchValue()).then((res: any) => {
                setFacilityCount(res.facility_count);
                setCompanyCount(res.company_count);
                setLoading(false);
            })

        }, 500);

        return () => clearTimeout(timer);
    }, [contractCategories, usages, contractUsages, loads,
        isCustomUsage, customUsageFrom, customUsageTo,
        isCustomContractUsage, customContractUsageFrom, customContractUsageTo,
        isCustomLoad, customLoadFrom, customLoadTo,
        groupsState]);

    const getCount = async (search: any) => {
        let q: any = {};
        if (search?.contract_categories && search.contract_categories.length > 0) {
            q.contract_categories = search.contract_categories;
        }
        if (search?.load && search.load.length > 0) {
            q.load = search.load;
        }
        if (search?.load_custom_from >= 0) {
            q.load_custom_from = search.load_custom_from;
        }
        if (search?.load_custom_to >= 0) {
            q.load_custom_to = search.load_custom_to;
        }
        if (search?.contract_usage && search.contract_usage.length > 0) {
            q.contract_usage = search.contract_usage;
        }
        if (search?.contract_usage_from >= 0) {
            q.contract_usage_from = search.contract_usage_from;
        }
        if (search?.contract_usage_to >= 0) {
            q.contract_usage_to = search.contract_usage_to;
        }
        if (search?.usage && search.usage.length > 0) {
            q.usage = search.usage;
        }
        if (search?.usage_custom_from >= 0) {
            q.usage_custom_from = search.usage_custom_from;
        }
        if (search?.usage_custom_to >= 0) {
            q.usage_custom_to = search.usage_custom_to;
        }
        if (search?.industry && search.industry.length > 0) {
            q.industry = search.industry;
        }
        if (search?.area && search.area.length > 0) {
            q.area = search.area;
        }
        const body = {
            mode: 'company',
            vendor_id: vendorInfo?.vendor_id,
            user_id: userInfo?.id,
            conditions: q,
            limit: 0,
            offset: 0,
        }
        let response = await fetch(`${api_url}/getOpportunitiesBySearchConditions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
        const res = await response.json();
        return res.data;
    }



    return (
        <div className="modal-content">

            <form id="search-form-detail" action="search_result" method="get">
                <Form.Control type="hidden" name="mode" />
                <Form.Control type="hidden" name="category" />

                <div className="modal-body p-0">
                    <section className="section p-0 text-xs-2">
                        <div className="section-wrapper" id="pinkSection">
                            <div style={{ backgroundColor: "#e9ad54" }} className="text-white py-5px px-2 fw-400 text-xs-2">
                                <div onClick={() => setSectionOpen((prev) => ({ ...prev, pink: !prev.pink }))}
                                    className={`mr-4 d-inline-block action-class ${sectionOpen.pink ? 'rotate-img-180' : ''}`}
                                    data-action="modal-action-class-wrapper-5"><img className="img  height-15" src="assets/images/other/up-arrow-white.svg" />
                                </div>
                                <img className="img img-fluid height-30 mr-2" src="assets/images/other/icon-list-clip-art-02-bg-white-circle.svg"

                                />契約種別から探す
                            </div>
                            {
                                sectionOpen.pink ? <div className="p-4 action-class-wrapper modal-action-class-wrapper-5 open">
                                    <div className="mb-12 line-height-2">
                                        <div className="row">
                                            <div className="text-pink-check-box">
                                                <div className="mb-12">
                                                    {contractCategories.map((contractCategory, index) => (
                                                        <div className="form-check form-check-inline" key={index}>
                                                            <input className="form-check-input childCheckBox mt-1" type="checkbox" id={"pink0" + index}
                                                                name="contract_categories[]"
                                                                checked={contractCategory.checked}
                                                                value={contractCategory.value} onChange={handleContractCategoriesChange(index)} />
                                                            <label className="form-check-label text-balck-02">{contractCategory.label}</label>
                                                        </div>
                                                    ))}
                                                    {/* <div className="row col-3">
                                                    <input className="col-1" type="checkbox" id="pink01" name="contract_categories[]" value="1" onClick={handleContractCategories} />
                                                    <label className="form-check-label col-10 text-black-02">特別高圧</label>
                                                </div>
                                                <div className="row col-3">
                                                    <input className="col-1" type="checkbox" id="pink02" name="contract_categories[]" value="2" onClick={handleContractCategories} />
                                                    <label className="form-check-label col-10 text-black-02">高圧電力</label>
                                                </div>
                                                <div className="row col-3">
                                                    <input className="col-1" type="checkbox" id="pink03" name="contract_categories[]" value="3" onClick={handleContractCategories} />
                                                    <label className="form-check-label col-10 text-black-02">従量電灯</label>
                                                </div>
                                                <div className="row col-3">
                                                    <input className="col-1" type="checkbox" id="pink04" name="contract_categories[]" value="4" onClick={handleContractCategories} />
                                                    <label className="form-check-label col-10 text-black-02">低圧電力</label>
                                                </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> : null
                            }
                        </div>
                        <div className="section-wrapper" id="blueSection">
                            <div className="bg-blue-05 text-white py-5px px-2 fw-400 text-xs-2">
                                <div onClick={() => setSectionOpen((prev) => ({ ...prev, blue: !prev.blue }))} className={`mr-4 d-inline-block action-class ${sectionOpen.blue ? 'rotate-img-180' : ''}`} data-action="modal-action-class-wrapper-1">
                                    <img className="img  height-15" src="assets/images/other/up-arrow-white.svg" />
                                </div>
                                <img className="img  height-30 mr-2" src="assets/images/other/icon-map-pin-bg-white-circle.svg" />地域から探す
                            </div>
                            {
                                sectionOpen.blue ?
                                    <div className="p-4 action-class-wrapper modal-action-class-wrapper-1 open">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                {/* <div className="text-blue-check-box">
                                            <div className="mb-3">
                                                <div className="row col-4">
                                                    <input className="col-1" type="checkbox" id="inlineModalCheckbox1" name="area[]" value="a1" />
                                                    <label style={{ color: "#7893bd" }} className="form-check-label col-10 text-black-02">北海道電力管内</label>
                                                </div>
                                            </div>
                                        </div> */}

                                                {/* 地域 */}
                                                {prefectureGroups.slice(0, 5).map((group, groupIndex) => (
                                                    <div className="checkbox-wrapper" key={groupIndex}>
                                                        <div className="mb-3">
                                                            <div className="text-ass-deep-demo text-blue-check-box">
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input parentCheckBox"
                                                                        type="checkbox"
                                                                        checked={group.parent.checked}
                                                                        onChange={(e) => handleParentChange(groupIndex)(e)}
                                                                        id={group.parent.value}
                                                                    />
                                                                    <label style={{ color: "#7893bd" }}
                                                                        className="form-check-label text-black-02"
                                                                        htmlFor={group.parent.value}
                                                                    >
                                                                        {group.parent.label}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <hr className="my-1" />
                                                            <div className="child px-3">
                                                                {group.children.map((child, childIndex) => (
                                                                    <div className="form-check form-check-inline" key={childIndex}>
                                                                        <input
                                                                            className="form-check-input childCheckBox"
                                                                            type="checkbox"
                                                                            checked={child.checked}
                                                                            onChange={(e) => handleChildChange(groupIndex, childIndex)(e)} // childIndexを渡す
                                                                        />
                                                                        <label className="form-check-label">{child.label}</label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                            <div className="col-lg-6">

                                                {/* 地域 */}
                                                {prefectureGroups.slice(5).map((group, groupIndex) =>
                                                (
                                                    <div className="checkbox-wrapper">
                                                        <div key={groupIndex} className="mb-3">
                                                            <div className="text-ass-deep-demo text-blue-check-box">
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input parentCheckBox"
                                                                        id={group.parent.value}
                                                                        type="checkbox" checked={group.parent.checked} onChange={handleParentChange(groupIndex + 5)} />
                                                                    <label style={{ color: "#7893bd" }}
                                                                        htmlFor={group.parent.value}
                                                                        className="form-check-label text-black-02">{group.parent.label}</label>
                                                                </div>
                                                            </div>
                                                            <hr className="my-1" />
                                                            <div className="child px-3 mb-3">
                                                                {group.children.map((child, childIndex) => (
                                                                    <div className="form-check form-check-inline" key={childIndex}>
                                                                        <input
                                                                            className="form-check-input childCheckBox"
                                                                            type="checkbox"
                                                                            checked={child.checked}
                                                                            onChange={handleChildChange(groupIndex + 5, childIndex)}
                                                                        />
                                                                        <label className="form-check-label">{child.label}</label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                )}
                                                {/* <div className="mb-3">
                                            <div className="text-blue-check-box">
                                                <div className="row col-4">
                                                    <input className="col-1" type="checkbox" id="inlineModalCheckbox101" name="area[]" value="a0" />
                                                    <label style={{ color: "#7893bd" }} className="form-check-label col-10 text-black-02" >沖縄電力管内</label>
                                                </div>
                                            </div>
                                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                        <div className="section-wrapper" id="orangeSection">
                            <div className="bg-orange-03 text-white py-5px px-2 fw-400 text-xs-2">
                                <div
                                    onClick={() => setSectionOpen((prev) => ({ ...prev, orange: !prev.orange }))}
                                    className={`mr-4 d-inline-block action-class ${sectionOpen.orange ? 'rotate-img-180' : ''}`}
                                >
                                    <img className="img img-fluid height-15" src="assets/images/other/up-arrow-white.svg" alt="up arrow" />
                                </div>

                                <img className="img img-fluid height-30 mr-2" src="assets/images/other/icon-man-bg-white-circle.svg" alt="icon man" />
                                業種から探す
                            </div>
                            {sectionOpen.orange && (
                                <div className="p-4 action-class-wrapper modal-action-class-wrapper-2 open">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            {/* <div className="text-orange-check-box">
                                            <div className="mb-3">
                                                <div className="row col-4">
                                                    <input className="col-1" type="checkbox" id="orange01" name="industry[]" value="i1" />
                                                    <label style={{ color: "#e29966" }} className="form-check-label col-10 text-black-02" >水産・農林業</label>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <div className="row col-4">
                                                    <input className="col-1" type="checkbox" id="orange02" name="industry[]" value="i2" />
                                                    <label style={{ color: "#e29966" }} className="form-check-label col-10 text-black-02" >鉱業</label>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <div className="row col-4">
                                                    <input className="col-1" type="checkbox" id="orange03" name="industry[]" value="i3" />
                                                    <label style={{ color: "#e29966" }} className="form-check-label col-10 text-black-02" >建設業</label>
                                                </div>
                                            </div>
                                        </div> */}
                                            {industryGroups.slice(0, 9).map((group, groupIndex) =>
                                            (
                                                <div className="checkbox-wrapper">
                                                    <div key={groupIndex} className="mb-3">
                                                        <div className="text-ass-deep-demo text-orange-check-box">
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input parentCheckBox"
                                                                    type="checkbox"
                                                                    id={group.parent.value}
                                                                    checked={group.parent.checked}
                                                                    onChange={handleParentChange(groupIndex + 10)} />
                                                                <label style={{ color: "#e29966" }}
                                                                    htmlFor={group.parent.value}
                                                                    className="form-check-label text-balck-02">{group.parent.label}</label>
                                                            </div>
                                                        </div>
                                                        <hr className="my-1" />
                                                        <div className="child px-3 mb-3">
                                                            {group.children.map((child, childIndex) => (
                                                                <div className="form-check form-check-inline" key={childIndex}>
                                                                    <input
                                                                        className="form-check-input childCheckBox"
                                                                        type="checkbox"
                                                                        checked={child.checked}
                                                                        onChange={handleChildChange(groupIndex + 10, childIndex)}
                                                                    />
                                                                    <label className="form-check-label">{child.label}</label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            )}
                                            {/* <div className="text-orange-check-box mb-3">
                                            <div className="row col-4">
                                                <input className="col-1" type="checkbox" id="orange20" name="industry[]" value="i5" />
                                                <label style={{ color: "#e29966" }} className="form-check-label col-10 text-black-02" >電気・ガス</label>
                                            </div>
                                        </div> */}
                                        </div>
                                        <div className="col-lg-6">
                                            {industryGroups.slice(9).map((group, groupIndex) =>
                                            (
                                                <div className="checkbox-wrapper">
                                                    <div key={groupIndex} className="mb-3">

                                                        <div key={groupIndex} className="text-ass-deep-demo text-orange-check-box">
                                                            <div className="form-check form-check-inline">
                                                                {/* <div className="row col-4"> */}
                                                                <input
                                                                    id={group.parent.value}
                                                                    className="form-check-input parentCheckBox" type="checkbox" checked={group.parent.checked} onChange={handleParentChange(groupIndex + 19)} />
                                                                <label style={{ color: "#e29966" }}
                                                                    htmlFor={group.parent.value}
                                                                    className="form-check-label text-balck-02">{group.parent.label}</label>
                                                                {/* </div> */}
                                                            </div>
                                                        </div>

                                                        <hr className="my-1" />
                                                        <div className="child px-3 mb-3">
                                                            {group.children.map((child, childIndex) => (
                                                                <div className="form-check form-check-inline" key={childIndex}>
                                                                    <input

                                                                        className="form-check-input childCheckBox"
                                                                        type="checkbox"
                                                                        checked={child.checked}
                                                                        onChange={handleChildChange(groupIndex + 19, childIndex)}
                                                                    />
                                                                    <label className="form-check-label">{child.label}</label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            )}
                                            {/* <div className="text-orange-check-box mb-3">
                                            <div className="row col-4">
                                                <input className="col-1" type="checkbox" id="orange34" name="industry[]" value="i9" />
                                                <label style={{ color: "#e29966" }} className="form-check-label col-10 text-black-02" >不動産業</label>
                                            </div>
                                        </div>
                                        <div className="text-orange-check-box mb-3">
                                            <div className="row col-4">
                                                <input className="col-1" type="checkbox" id="orange35" name="industry[]" value="i0" />
                                                <label style={{ color: "#e29966" }} className="form-check-label col-10 text-black-02" >サービス業</label>
                                            </div>
                                        </div> */}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="section-wrapper" id="greenSection">
                            <div className="bg-green-02 text-white py-5px px-2 fw-400 text-xs-2">
                                <div
                                    onClick={() => setSectionOpen((prev) => ({ ...prev, green: !prev.green }))}
                                    className={`mr-4 d-inline-block action-class ${sectionOpen.green ? 'rotate-img-180' : ''}`}
                                    data-action="modal-action-class-wrapper-3"
                                >
                                    <img className="img height-15" src="assets/images/other/up-arrow-white.svg" />
                                </div>
                                <img className="img height-30 mr-2" src="assets/images/other/icon-line-chart-graph-bg-white-circle.svg" />
                                使用量から探す
                            </div>

                            {sectionOpen.green && (
                                <div className="p-4 action-class-wrapper modal-action-class-wrapper-3 open">
                                    <div className="mb-3 line-height-2">
                                        <label className="form-check-label text-black-02">年間使用電力量</label>
                                        <hr className="mt-1 mb-4" />
                                        <div className="green-checkbox">
                                            {usages.map((usage, index) => (
                                                <div className="form-check form-check-inline" key={index}>
                                                    <input
                                                        className="form-check-input childCheckBox"
                                                        type="checkbox"
                                                        id={usage.value}
                                                        name="usage[]"
                                                        value={usage.value}
                                                        checked={usage.checked}
                                                        onChange={(e) => handleUsagesChange(index, e.target.checked)}
                                                    />
                                                    <label className="form-check-label" htmlFor={usage.value}>
                                                        <div className="checkbox-label">
                                                            <div className="float-left">
                                                                <img className="img height-40 mr-3" src={`assets/images/other/green-0${index + 1}.svg`} />
                                                            </div>
                                                            <div className="float-left text-sm label-text mt-3">
                                                                {usage.label}
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="text-ass-deep-demo text-green-check-box">
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="orange36"
                                                value="orange36"
                                                onChange={(e) => setIsCustomUsage(e.target.checked)}
                                                checked={isCustomUsage}
                                            />
                                            <label className="form-check-label" htmlFor="orange36">カスタム設定</label>
                                        </div>
                                    </div>

                                    <div className="form-group mb-3 p-3">
                                        <label className="d-block" htmlFor="name">年間使用電力量</label>

                                        <div className="d-inline-block">
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    onChange={(e) => setCustomUsageFrom(Number(e.target.value))}
                                                    disabled={!isCustomUsage}
                                                    className="form-control rounded-0 w-max-150 orange36"
                                                    id="name"
                                                    placeholder=""
                                                    name="usage_custom_from"
                                                    value={customUsageFrom}
                                                />
                                                <div className="input-group-append fw-300">
                                                    <span className="mx-2 mt-1">kWh ～</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-inline-block">
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    onChange={(e) => setCustomUsageTo(Number(e.target.value))}
                                                    disabled={!isCustomUsage}
                                                    className="form-control rounded-0 w-max-150 orange36"
                                                    id="name1"
                                                    placeholder=""
                                                    name="usage_custom_to"
                                                    value={customUsageTo}
                                                />
                                                <div className="input-group-append fw-300">
                                                    <span className="mx-2 mt-1">kWh</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="section-wrapper" id="yellowSection">
                            <div className="bg-yellow-04 text-white py-5px px-2 fw-400 text-xs-2">
                                <div
                                    onClick={() =>
                                        setSectionOpen((prev) => ({ ...prev, yellow: !prev.yellow }))
                                    }
                                    className={`mr-4 d-inline-block action-class ${sectionOpen.yellow ? 'rotate-img-180' : ''
                                        }`}
                                    data-action="modal-action-class-wrapper-5"
                                >
                                    <img
                                        className="img img-fluid height-15"
                                        src="assets/images/other/up-arrow-white.svg"
                                        alt="toggle"
                                    />
                                </div>
                                <img
                                    className="img img-fluid height-30 mr-2"
                                    src="assets/images/other/icon-list-clip-art-02-bg-white-circle.svg"
                                    alt="icon"
                                />
                                契約電力から探す
                            </div>

                            {sectionOpen.yellow && (
                                <div className="p-4 action-class-wrapper modal-action-class-wrapper-5 open">
                                    <div className="mb-3 line-height-2">
                                        <label className="form-check-label text-black-02">契約電力</label>
                                        <hr className="mt-1 mb-4" />
                                        <div className="green-checkbox yellow-checkbox">
                                            {contractUsages.map((contractUsage, index) => (
                                                <div className="form-check form-check-inline" key={index}>
                                                    <input
                                                        className="form-check-input childCheckBox"
                                                        type="checkbox"
                                                        id={contractUsage.value}
                                                        name="contract_usage[]"
                                                        value={contractUsage.value}
                                                        checked={contractUsage.checked}
                                                        onChange={(e) =>
                                                            handleContractUsagesChange(index, e.target.checked)
                                                        }
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={contractUsage.value}
                                                    >
                                                        <div className="checkbox-label">
                                                            <div className="float-left">
                                                                <img
                                                                    className="img img-fluid height-40 mr-3"
                                                                    src={`assets/images/other/yellow-0${index + 1}.svg`}
                                                                    alt="icon"
                                                                />
                                                            </div>
                                                            <div className="float-left text-sm label-text mt-3">
                                                                {contractUsage.label}
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* カスタム設定 */}
                                    <div className="text-yellow-check-box">
                                        <div className="form-check form-check-inline">
                                            <input
                                                onChange={(e) => setIsCustomContractUsage(e.target.checked)}
                                                className="form-check-input childCheckBox"
                                                type="checkbox"
                                                id="yellow36"
                                                value="yellow36"
                                                checked={isCustomContractUsage}
                                            />
                                            <label
                                                className="form-check-label text-yellow-04"
                                                htmlFor="yellow36"
                                            >
                                                カスタム設定
                                            </label>
                                        </div>
                                    </div>

                                    {/* カスタム設定の入力フォーム */}
                                    <div className="form-group mb-3 p-3">
                                        <label className="d-block text-theme">契約電力</label>

                                        <div className="d-inline-block">
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    onChange={(e) =>
                                                        setCustomContractUsageFrom(Number(e.target.value))
                                                    }
                                                    disabled={!isCustomContractUsage}
                                                    className="form-control rounded-0 w-max-150 yellow36 inputDA"
                                                    id="nameyellow"
                                                    name="contract_usage_from"
                                                    value={customContractUsageFrom}
                                                />
                                                <div className="input-group-append fw-300">
                                                    <span className="mx-2 mt-1">kW ～</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-inline-block">
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    onChange={(e) =>
                                                        setCustomContractUsageTo(Number(e.target.value))
                                                    }
                                                    disabled={!isCustomContractUsage}
                                                    className="form-control rounded-0 w-max-150 yellow36 inputDA"
                                                    id="name1yellow"
                                                    name="contract_usage_to"
                                                    value={customContractUsageTo}
                                                />
                                                <div className="input-group-append fw-300">
                                                    <span className="mx-2 mt-1">kW</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>


                        <div className="action-class-wrapper close-open-wrapper open">
                            <div className="section-wrapper" id="redSection">
                                <div className="bg-red-03 text-white py-5px px-2 fw-400 text-xs-2">
                                    <div
                                        onClick={() =>
                                            setSectionOpen((prev) => ({ ...prev, red: !prev.red }))
                                        }
                                        className={`mr-4 d-inline-block action-class ${sectionOpen.red ? 'rotate-img-180' : ''
                                            }`}
                                        data-action="modal-action-class-wrapper-4"
                                    >
                                        <img
                                            className="img img-fluid height-15"
                                            src="assets/images/other/up-arrow-white.svg"
                                            alt="Up Arrow"
                                        />
                                    </div>
                                    <img
                                        className="img img-fluid height-30 mr-2"
                                        src="assets/images/other/icon-pie-chart-graph-bg-white-circle.svg"
                                        alt="Icon"
                                    />
                                    負荷率から探す
                                </div>

                                {sectionOpen.red && (
                                    <div className="action-class-wrapper modal-action-class-wrapper-4 open">
                                        <div className="p-4">
                                            <div className="mb-3 line-height-2">
                                                <label className="form-check-label text-black-02">年負荷率</label>
                                                <hr className="mt-1 mb-4" />
                                                <div className="green-checkbox red-checkbox">
                                                    {loads.map((load, index) => (
                                                        <div className="form-check form-check-inline" key={index}>
                                                            <input
                                                                className="form-check-input childCheckBox"
                                                                type="checkbox"
                                                                id={load.value}
                                                                name="load[]"
                                                                value={load.value}
                                                                checked={load.checked}
                                                                onChange={(e) => handleLoadsChange(index, e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor={load.value}>
                                                                <div className="checkbox-label">
                                                                    <div className="float-left">
                                                                        <img
                                                                            className="img img-fluid height-40 mr-3"
                                                                            src={`assets/images/other/red-0${index + 1}.svg`}
                                                                        />
                                                                    </div>
                                                                    <div className="float-left text-sm label-text mt-3">
                                                                        {load.label}
                                                                    </div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div>
                                                <div className="text-ass-deep-demo text-red-check-box">
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="orange37"
                                                            value="orange37"
                                                            onChange={(e) => setIsCustomLoad(e.target.checked)}
                                                            checked={isCustomLoad}
                                                        />
                                                        <label className="form-check-label" htmlFor="orange37">
                                                            カスタム設定
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3 p-3">
                                                    <label className="d-block" htmlFor="name">年負荷率</label>

                                                    <div className="d-inline-block">
                                                        <div className="input-group">
                                                            <input
                                                                type="number"
                                                                onChange={(e) => setCustomLoadFrom(Number(e.target.value))}
                                                                disabled={!isCustomLoad}
                                                                className="form-control rounded-0 w-max-150 orange37"
                                                                id="load_custom_from"
                                                                placeholder=""
                                                                name="load_custom_from"
                                                                value={customLoadFrom}
                                                            />
                                                            <div className="input-group-append fw-300">
                                                                <span className="mx-2 mt-1">％ ～</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="d-inline-block">
                                                        <div className="input-group">
                                                            <input
                                                                type="number"
                                                                onChange={(e) => setCustomLoadTo(Number(e.target.value))}
                                                                disabled={!isCustomLoad}
                                                                className="form-control rounded-0 w-max-150 orange37"
                                                                id="load_custom_to"
                                                                placeholder=""
                                                                name="load_custom_to"
                                                                value={customLoadTo}
                                                            />
                                                            <div className="input-group-append fw-300">
                                                                <span className="mx-2 mt-1">％</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="p-4">
                            <div className="border-5-ass rounded-12">
                                <div className="p-3 fw-400">
                                    <div className="text-xs">選択中</div>
                                    <hr className="mt-2" />
                                    <div className="mb-1">
                                        <div className="d-inline-block height-36">
                                            <img className="img  height-20 me-1" src="assets/images/other/icon-list-clip-art-02.svg" />契約種別 ：
                                        </div>


                                        <div className="pink-btn-wrapper d-inline-block">
                                            {
                                                contractCategoryLabels.map((labelObj) => (
                                                    <div className="closed-wrapper bg-ass-table d-inline-block pl-3 pr-2 py-1 mr-1 mb-2 rounded">
                                                        {labelObj.label}
                                                        <button type="button" className="btn-closed border-0 px-2 pb-1 ml-1"
                                                            onClick={() => handleContractCategoriesClose(labelObj.index)}>
                                                            <img className="img img-fluid height-15" src="assets/images/other/icon-cross.svg" />
                                                        </button>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className="mb-1">
                                        <div className="d-inline-block height-36">
                                            <img className="img  height-20 me-1" src="assets/images/other/icon-map.svg" />地域 ：
                                        </div>
                                        <div className="blue-btn-wrapper d-inline-block">
                                            {
                                                prefectureLabels.map((labelObj) => (
                                                    <>
                                                        <div className="closed-wrapper bg-ass-table d-inline-block pl-3 pr-2 py-1 mr-1 mb-2 rounded">
                                                            {labelObj.label}
                                                            <button type="button" className="btn-closed border-0 px-2 pb-1 ml-1" onClick={() => handleChildClose(labelObj.groupIndex, labelObj.childIndex)}>
                                                                <img className="img img-fluid height-15" src="assets/images/other/icon-cross.svg" />
                                                            </button>
                                                        </div>
                                                    </>
                                                )

                                                )
                                            }

                                        </div>
                                    </div>
                                    <div className="mb-1">
                                        <div className="d-inline-block height-36">
                                            <img className="img  height-20 me-1" src="assets/images/other/icon-man.svg" />業種 ：
                                        </div>
                                        <div className="orange-btn-wrapper d-inline-block">
                                            {
                                                industryLabels.map((labelObj) => (
                                                    <>
                                                        <div className="closed-wrapper bg-ass-table d-inline-block pl-3 pr-2 py-1 mr-1 mb-2 rounded">
                                                            {labelObj.label}
                                                            <button type="button" className="btn-closed border-0 px-2 pb-1 ml-1" onClick={() => handleChildClose(labelObj.groupIndex, labelObj.childIndex)}>
                                                                <img className="img img-fluid height-15" src="assets/images/other/icon-cross.svg" />
                                                            </button>
                                                        </div>
                                                    </>
                                                )

                                                )
                                            }

                                        </div>
                                    </div>
                                    <div className="mb-1">
                                        <div className="d-inline-block height-36">
                                            <img className="img  height-15 me-1" src="assets/images/other/icon-line-chart.svg" />使用量 ：
                                        </div>
                                        <div className="green-btn-wrapper d-inline-block">
                                            {
                                                usages.map((usage, index) => (
                                                    usage.checked && <>
                                                        <div className="closed-wrapper bg-ass-table d-inline-block pl-3 pr-2 py-1 mr-1 mb-2 rounded">
                                                            {usage.label}
                                                            <button type="button" className="btn-closed border-0 px-2 pb-1 ml-1" onClick={() => handleUsagesChange(index, false)}>
                                                                <img className="img img-fluid height-15" src="assets/images/other/icon-cross.svg" />
                                                            </button>
                                                        </div>
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className="mb-1">
                                        <div className="d-inline-block height-36">
                                            <img className="img  height-15 me-1" src="assets/images/other/icon-list-clip-art-02.svg" />契約電力 ：
                                        </div>
                                        <div className="yellow-btn-wrapper d-inline-block">
                                            {
                                                contractUsages.map((contractUsage, index) => (
                                                    contractUsage.checked && <>
                                                        <div className="closed-wrapper bg-ass-table d-inline-block pl-3 pr-2 py-1 mr-1 mb-2 rounded">
                                                            {contractUsage.label}
                                                            <button type="button" className="btn-closed border-0 px-2 pb-1 ml-1" onClick={() => handleContractUsagesChange(index, false)}>
                                                                <img className="img img-fluid height-15" src="assets/images/other/icon-cross.svg" />
                                                            </button>
                                                        </div>
                                                    </>
                                                ))
                                            }

                                        </div>
                                    </div>
                                    <div className="action-class-wrapper close-open-wrapper open">
                                        <div className="mb-1">
                                            <div className="d-inline-block height-36">
                                                <img className="img  height-20 me-1" src="assets/images/other/icon-pie-chart-graph.svg" />負荷率 ：
                                            </div>
                                            <div className="red-btn-wrapper d-inline-block">
                                                {
                                                    loads.map((load, index) => (
                                                        load.checked && <>
                                                            <div className="closed-wrapper bg-ass-table d-inline-block pl-3 pr-2 py-1 mr-1 mb-2 rounded">
                                                                {load.label}
                                                                <button type="button" className="btn-closed border-0 px-2 pb-1 ml-1" onClick={() => handleLoadsChange(index, false)}>
                                                                    <img className="img img-fluid height-15" src="assets/images/other/icon-cross.svg" />
                                                                </button>
                                                            </div>
                                                        </>
                                                    ))
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mt-2 mb-4" />
                                </div>
                                <div className="text-center fw-400 buildings-left-right pb-4">
                                    <div className="">
                                        <span className="text-sm fw-500">応札期間中の案件：</span>

                                        {loading ? <Spinner animation="border" variant="danger" />
                                            :
                                            <>
                                                <span className="text-xl text-red-theme fw-700" id="all_facility_count">
                                                    {facilityCount}
                                                </span><span className="text-xs mr-4">施設
                                                </span><span className="text-xs-2" id="all_company_count"> (企業数 {companyCount}社)</span>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center mt-5 mb-lg-5 mb-4">
                            <button type="button" id="goSearch" className="btn btn-lg btn-theme btn-danger rounded-pill px-lg-5 px-3 mr-2"
                                onClick={handleSearch} >
                                <span className="mx-3">結果を表示する</span>
                            </button>
                        </div>
                    </section>
                </div>
            </form>
        </div>
    )
}

export default Search;